/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiPaginatedResponseOfPlanPickerResponse } from '../model';
// @ts-ignore
import { ApiResponseOfPlanPickerResponse } from '../model';
// @ts-ignore
import { ApiResponseOfPlanPickerResponseArray } from '../model';
// @ts-ignore
import { PlanPickerBody } from '../model';
// @ts-ignore
import { TargetPlatform } from '../model';
/**
 * PlanPickerApi - axios parameter creator
 * @export
 */
export const PlanPickerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new plan picker configuration.
         * @param {PlanPickerBody} planPickerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (planPickerBody: PlanPickerBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'planPickerBody' is not null or undefined
            assertParamExists('create', 'planPickerBody', planPickerBody)
            const localVarPath = `/api/v1/planPicker`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planPickerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves plan picker configurations by country code.
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCountry: async (country: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getByCountry', 'country', country)
            const localVarPath = `/api/v1/planPicker/country/{country}`
                .replace(`{${"country"}}`, encodeURIComponent(String(country)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a plan picker configuration by ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getById', 'id', id)
            const localVarPath = `/api/v1/planPicker/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all plan picker configurations with pagination support.
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [country] Filter by country code
         * @param {Array<TargetPlatform>} [platforms] Filter by target platforms
         * @param {boolean} [includeDeleted] Include deleted records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated: async (limit?: number, page?: number, country?: string, platforms?: Array<TargetPlatform>, includeDeleted?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/planPicker`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (platforms) {
                localVarQueryParameter['platforms'] = platforms;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hardDelete', 'id', id)
            const localVarPath = `/api/v1/planPicker/{id}/hard`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft deletes a plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/planPicker/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restores a soft-deleted plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restore', 'id', id)
            const localVarPath = `/api/v1/planPicker/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing plan picker configuration.
         * @param {string} id 
         * @param {PlanPickerBody} planPickerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, planPickerBody: PlanPickerBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'planPickerBody' is not null or undefined
            assertParamExists('update', 'planPickerBody', planPickerBody)
            const localVarPath = `/api/v1/planPicker/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planPickerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanPickerApi - functional programming interface
 * @export
 */
export const PlanPickerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanPickerApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new plan picker configuration.
         * @param {PlanPickerBody} planPickerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(planPickerBody: PlanPickerBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlanPickerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(planPickerBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves plan picker configurations by country code.
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCountry(country: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlanPickerResponseArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCountry(country, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a plan picker configuration by ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlanPickerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves all plan picker configurations with pagination support.
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [country] Filter by country code
         * @param {Array<TargetPlatform>} [platforms] Filter by target platforms
         * @param {boolean} [includeDeleted] Include deleted records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginated(limit?: number, page?: number, country?: string, platforms?: Array<TargetPlatform>, includeDeleted?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPaginatedResponseOfPlanPickerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginated(limit, page, country, platforms, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Permanently deletes a plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hardDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hardDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft deletes a plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Restores a soft-deleted plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restore(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlanPickerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restore(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates an existing plan picker configuration.
         * @param {string} id 
         * @param {PlanPickerBody} planPickerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, planPickerBody: PlanPickerBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlanPickerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, planPickerBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlanPickerApi - factory interface
 * @export
 */
export const PlanPickerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanPickerApiFp(configuration)
    return {
        /**
         * Creates a new plan picker configuration.
         * @param {PlanPickerBody} planPickerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(planPickerBody: PlanPickerBody, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponse> {
            return localVarFp.create(planPickerBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves plan picker configurations by country code.
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCountry(country: string, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponseArray> {
            return localVarFp.getByCountry(country, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a plan picker configuration by ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id: string, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponse> {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all plan picker configurations with pagination support.
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [country] Filter by country code
         * @param {Array<TargetPlatform>} [platforms] Filter by target platforms
         * @param {boolean} [includeDeleted] Include deleted records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated(limit?: number, page?: number, country?: string, platforms?: Array<TargetPlatform>, includeDeleted?: boolean, options?: any): AxiosPromise<ApiPaginatedResponseOfPlanPickerResponse> {
            return localVarFp.getPaginated(limit, page, country, platforms, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.hardDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft deletes a plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Restores a soft-deleted plan picker configuration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(id: string, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponse> {
            return localVarFp.restore(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing plan picker configuration.
         * @param {string} id 
         * @param {PlanPickerBody} planPickerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, planPickerBody: PlanPickerBody, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponse> {
            return localVarFp.update(id, planPickerBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanPickerApi - interface
 * @export
 * @interface PlanPickerApi
 */
export interface PlanPickerApiInterface {
    /**
     * Creates a new plan picker configuration.
     * @param {PlanPickerBody} planPickerBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApiInterface
     */
    create(planPickerBody: PlanPickerBody, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponse>;

    /**
     * Retrieves plan picker configurations by country code.
     * @param {string} country 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApiInterface
     */
    getByCountry(country: string, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponseArray>;

    /**
     * Retrieves a plan picker configuration by ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApiInterface
     */
    getById(id: string, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponse>;

    /**
     * Retrieves all plan picker configurations with pagination support.
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [country] Filter by country code
     * @param {Array<TargetPlatform>} [platforms] Filter by target platforms
     * @param {boolean} [includeDeleted] Include deleted records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApiInterface
     */
    getPaginated(limit?: number, page?: number, country?: string, platforms?: Array<TargetPlatform>, includeDeleted?: boolean, options?: any): AxiosPromise<ApiPaginatedResponseOfPlanPickerResponse>;

    /**
     * Permanently deletes a plan picker configuration.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApiInterface
     */
    hardDelete(id: string, options?: any): AxiosPromise<void>;

    /**
     * Soft deletes a plan picker configuration.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApiInterface
     */
    remove(id: string, options?: any): AxiosPromise<void>;

    /**
     * Restores a soft-deleted plan picker configuration.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApiInterface
     */
    restore(id: string, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponse>;

    /**
     * Updates an existing plan picker configuration.
     * @param {string} id 
     * @param {PlanPickerBody} planPickerBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApiInterface
     */
    update(id: string, planPickerBody: PlanPickerBody, options?: any): AxiosPromise<ApiResponseOfPlanPickerResponse>;

}

/**
 * PlanPickerApi - object-oriented interface
 * @export
 * @class PlanPickerApi
 * @extends {BaseAPI}
 */
export class PlanPickerApi extends BaseAPI implements PlanPickerApiInterface {
    /**
     * Creates a new plan picker configuration.
     * @param {PlanPickerBody} planPickerBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApi
     */
    public create(planPickerBody: PlanPickerBody, options?: any) {
        return PlanPickerApiFp(this.configuration).create(planPickerBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves plan picker configurations by country code.
     * @param {string} country 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApi
     */
    public getByCountry(country: string, options?: any) {
        return PlanPickerApiFp(this.configuration).getByCountry(country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a plan picker configuration by ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApi
     */
    public getById(id: string, options?: any) {
        return PlanPickerApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all plan picker configurations with pagination support.
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [country] Filter by country code
     * @param {Array<TargetPlatform>} [platforms] Filter by target platforms
     * @param {boolean} [includeDeleted] Include deleted records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApi
     */
    public getPaginated(limit?: number, page?: number, country?: string, platforms?: Array<TargetPlatform>, includeDeleted?: boolean, options?: any) {
        return PlanPickerApiFp(this.configuration).getPaginated(limit, page, country, platforms, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently deletes a plan picker configuration.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApi
     */
    public hardDelete(id: string, options?: any) {
        return PlanPickerApiFp(this.configuration).hardDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft deletes a plan picker configuration.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApi
     */
    public remove(id: string, options?: any) {
        return PlanPickerApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restores a soft-deleted plan picker configuration.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApi
     */
    public restore(id: string, options?: any) {
        return PlanPickerApiFp(this.configuration).restore(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing plan picker configuration.
     * @param {string} id 
     * @param {PlanPickerBody} planPickerBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanPickerApi
     */
    public update(id: string, planPickerBody: PlanPickerBody, options?: any) {
        return PlanPickerApiFp(this.configuration).update(id, planPickerBody, options).then((request) => request(this.axios, this.basePath));
    }
}
